export default __webpack_public_path__ + "static/media/frame_zh_cn_pc@2x.e590ca8e.png";